import {RadioModalDataOption} from "@portal/shared/models/radio-modal-data-option";

export class RadioModalData {
    options: RadioModalDataOption[];
    title: string;
    types: RadioModalDataType [];
}

export enum RadioModalDataType {
    Radio = 1,
    BetweenDates = 2,
    Checkbox = 3,
}
